export const presetIcons = {
  animals: ["crab", "fish", "fish-1", "pearl", "shrimp"],
  appliances: [
    "air-fryer",
    "cooker",
    "deep-fryer",
    "fridge",
    "fridge-1",
    "juice-1",
    "kettle",
    "mixer",
    "oven",
    "oven-1",
    "rice-cooker",
    "thermomix",
    "toaster",
    "waffle",
  ],
  drinks: ["alcohol", "beverage", "cocktail", "juice", "sauce", "sauce-bottle"],
  food: [
    "appetizer",
    "cheese",
    "chicken-leg",
    "cookie",
    "egg",
    "food",
    "food-tray",
    "hamburger",
    "hive",
    "ice-cream",
    "loaf",
    "milk",
    "milk-box",
    "noodle",
    "peanut",
    "pie",
    "pizza",
    "salad",
    "sandwich",
    "snack",
    "soup",
  ],
  misc: [
    "baby",
    "baby-boy",
    "bone",
    "canned-food",
    "coins",
    "defrost",
    "diner",
    "dinner",
    "gluten-free",
    "healthcare",
    "heart",
    "hearts",
    "money-bag",
    "morning",
    "no-sugar",
    "pacifier",
    "sleep",
    "snowflake",
    "speedometer",
    "speedometer-1",
    "speedometer-2",
    "starry-night",
    "sunny",
    "wind",
  ],
  occasions: [
    "balloon",
    "bbq",
    "birthday-cake",
    "christmas-tree",
    "clapperboard",
    "confetti",
    "easter-egg",
    "fireworks",
    "gingerbread-man",
  ],
  produce: [
    "apple",
    "artichoke",
    "avocado",
    "beans",
    "carrot",
    "cereals",
    "eco-friendly",
    "mint",
    "nut",
    "pumpkin",
    "rambutan",
    "toadstool",
  ],
  sweets: ["dessert", "lollipop", "lollipop-1", "sweets"],
};
